<template>
  <v-list-group :value="false" exact color="">
    <template #activator>
      <v-list-item-icon>
        <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="subtitle-2">{{
        t(item.title)
      }}</v-list-item-title>
    </template>
    <menu-item-default
      v-for="(subItem, index) in item.children"
      :key="subItem.id"
      :v-testid="`sub-${item.id}-${index}`"
      :item="subItem"
      v-on="$listeners"
    />
  </v-list-group>
</template>

<script>
import MenuItemDefault from './MenuItemDefault';
import { useI18n } from 'vue-i18n-bridge';
import messages from './menu.i18n.json';
export default {
  name: 'MenuItemGroup',
  components: {
    MenuItemDefault
  },
  props: {
    level: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const { t } = useI18n({
      messages,
      inheritLocale: true,
      useScope: 'local'
    });

    return {
      t
    };
  }
};
</script>
